import React from "react";
import PouchInput from "components/PouchInput";
import PouchDateInput from "components/PouchDateInput";
import SortableHeaderCell from "components/SortableHeaderCell";
import { Column } from "components/table/Table";
import { Meet } from "types";
import get from "lodash/get";
import PouchCheckbox from "components/PouchCheckbox";

const InputCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties;
}) => {
  const restrictedMeetDoc = meet.restricted;

  const fieldName = ["refs", data.id, column.key];
  if (data.row === "header") {
    if (column.sortable) {
      return <SortableHeaderCell style={style} column={column} />;
    }
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    if (column.type === "checkbox") {
      return (
        <div style={style} className="table-cell-inner">
          <PouchCheckbox
            meetId={meet._id}
            documentId={restrictedMeetDoc._id}
            name={fieldName}
            value={get(data, column.key)}
          />
        </div>
      );
    } else if (column.type === "date") {
      return (
        <div style={style} className="table-cell-inner">
          <PouchDateInput
            meet={meet}
            documentId={restrictedMeetDoc._id}
            name={fieldName}
            value={get(data, column.key)}
          />
        </div>
      );
    } else {
      return (
        <div style={style} className="table-cell-inner">
          <PouchInput
            type={column.type === "number" ? "number" : "text"}
            meetId={meet._id}
            documentId={restrictedMeetDoc._id}
            name={fieldName}
            value={get(data, column.key)}
          />
        </div>
      );
    }
  }
};

export default InputCell;
